import type { IconData } from '@stacksjs/iconify-core'

export const circleClockFlat: IconData = {
  "body": "<g fill=\"none\" fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path fill=\"#8fbffa\" d=\"M1.5 24C1.5 11.574 11.574 1.5 24 1.5S46.5 11.574 46.5 24S36.426 46.5 24 46.5S1.5 36.426 1.5 24\"/><path fill=\"#2859c5\" d=\"M24 40c8.837 0 16-7.163 16-16S32.837 8 24 8S8 15.163 8 24s7.163 16 16 16\"/><path fill=\"#8fbffa\" d=\"M24 12.5a2.5 2.5 0 0 1 2.5 2.5v7.965l5.268 5.267a2.5 2.5 0 0 1-3.536 3.536l-6-6A2.5 2.5 0 0 1 21.5 24v-9a2.5 2.5 0 0 1 2.5-2.5\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default circleClockFlat
